import { useNavigate } from "react-router-dom";
import { useLang } from "../lib/lang";
import { pages } from "../lib/pagesCopy";
import { useSeo } from "../lib/seo";
import { PageHero } from "../components/PageHero";
import { SubNav } from "../components/SubNav";
import { Programs, Marquee } from "../components/Programs";
import { HowItWorks, WhoFor } from "../components/Sections";
import { Universities, Verify, Funding, HomeDisclaimer } from "../components/Trust";
import { CtaBand } from "../components/SiteFooter";

export default function Programmes() {
  const { lang } = useLang();
  const p = pages[lang].programmes;
  const navigate = useNavigate();
  useSeo({ title: "Online & Distance Programmes, Universities and EMI Guidance | Mirai Educations", description: "UG, PG, executive and diploma programmes in online and distance mode. Compare universities, learn about EMI and scholarship guidance, and verify on UGC-DEB before you apply.", path: "/programmes" });
  const enquire = (value) => navigate(`/contact?programme=${encodeURIComponent(value)}#contact`);
  return (
    <main data-testid="programmes-page">
      <PageHero eyebrow={p.eyebrow} title={p.title} text={p.text} testid="programmes-hero" />
      <SubNav items={p.sub} label={p.subLabel} />
      <Programs onEnquire={enquire} />
      <Marquee />
      <Universities />
      <HowItWorks />
      <WhoFor />
      <Funding />
      <Verify />
      <HomeDisclaimer />
      <CtaBand />
    </main>
  );
}
